import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const NonCommerceInfoContext = createContext(false);

function NonCommerceInfoProvider({ children, isNonCommerce }) {
  const nonCommercePdpApprovedBlockTypes = [
    'deptSearchesFAQ',
    'deptPdpSpecificVideoLockup',
    'deptPdpProductDetails',
    'deptFeaturedStatement',
    'deptCardRowReviews',
    'deptSocialGrid',
    'deptUGCGrid',
  ];

  const memoizedValue = useMemo(
    () => ({
      isNonCommerce: !!isNonCommerce,
      nonCommercePdpApprovedBlockTypes,
    }),
    [isNonCommerce]
  );

  return (
    <NonCommerceInfoContext.Provider value={memoizedValue}>
      {children}
    </NonCommerceInfoContext.Provider>
  );
}

NonCommerceInfoProvider.defaultProps = {
  isNonCommerce: false,
};

NonCommerceInfoProvider.propTypes = {
  children: PropTypes.node.isRequired,
  isNonCommerce: PropTypes.bool,
};

export { NonCommerceInfoProvider, NonCommerceInfoContext };
